﻿export class NotBusy {
    static eventName() { return 'NotBusy'; }

    constructor(public $element?: JQuery) { }

    eventName = NotBusy.eventName;
}